import type { ProductAnalyticsFeatureMatrix } from './types';

// Default hardened config used when the server/flag evaluation is unavailable
export const defaultFeatureMatrixValue: ProductAnalyticsFeatureMatrix = {
  charts: {
    visualization: {
      cohortFromChart: 'hidden',
    },
    trends: {
      events: {
        calculation: {
          aggregateProperties: [],
          frequencyPerUser: [],
        },
      },
    },
    flows: {
      visibility: 'hidden',
      eventsOfInterest: 'hidden',
    },
    firstTimeFilter: 'hidden',
  },
  cohorts: {
    staticCohort: {
      downloadCohort: 'hidden',
      uploadCohort: 'hidden',
    },
  },
  downloads: {
    users: {
      funnels: 'hidden',
      retention: 'hidden',
    },
  },
  userActivity: 'hidden',
};

export const warehouseWithDataExportSupportDefaultValue = ['snowflake-v2'];
